import React, { useState } from "react";
import styled from "styled-components";
import SideMenu from "components/admin/layout/SideMenu";
// import { Link as RouterLink } from "react-router-dom";

/* ===================== STYLES ===================== */

const AppWrapper = styled.div`
  width: 90%;
  margin: 0 auto;
`;

const Nav = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

const NavItem = styled.button<{ active: boolean }>`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: ${({ active }) => (active ? "black" : "grey")};
  font-weight: ${({ active }) => (active ? "600" : "400")};

  &:hover {
    text-decoration: underline;
  }
`;

const SaveWrapper = styled.div`
  margin: 4px 0;
  text-align: left;
`;

const SaveButton = styled.button`
  padding: 3px 10px;
  font-size: 13px;
  cursor: pointer;
`;

const Table = styled.table`
  width: 800px;
  border-collapse: collapse;

  td {
    padding: 3px 6px; /* minimalan razmak */
    vertical-align: middle;
    font-weight: 600;
  }

  td:first-child {
    width: 10px;
    padding-right: 6px;
  }

  label {
    white-space: nowrap;
  }

  input,
  select {
    width: 100%;
    padding: 3px 4px; /* kompaktan input */
    font-weight: 600;
  }
`;

const FullWidth = styled.div`
  width: 100%;
`;

const Page = styled.div`
  min-height: 100vh;
  width: 100%;
  background-color: #ffffff;
`;

/* ===================== COMPONENT ===================== */

type ViewType = "ALL" | "HM";

const DlUnitEdit: React.FC = () => {
  const [view, setView] = useState<ViewType>("ALL");

  return (
    <Page>
      <FullWidth>
        <div className="row">
          {/* SIDE MENU */}
          <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12">
            <SideMenu />
          </div>

          {/* CENTRAL CONTENT */}
          <div
            className="col-comp-central col-xl-10 col-lg-9 col-md-9 col-sm-12 offset-xl-1 offset-lg-1 offset-md-1"
            style={{ marginLeft: "15%", marginTop: "-10%" }}
          >
            <div className="App">
              <AppWrapper>
                {/* NAV */}
                <Nav>
                  <NavItem
                    active={view === "ALL"}
                    onClick={() => setView("ALL")}
                  >
                    ALL
                  </NavItem>
                  <NavItem active={view === "HM"} onClick={() => setView("HM")}>
                    HM
                  </NavItem>
                </Nav>

                {/* SAVE TOP */}
                <SaveWrapper>
                  <SaveButton>OK</SaveButton>
                </SaveWrapper>

                {/* FORM */}
                {view === "ALL" && (
                  <Table>
                    <tbody>
                      <tr>
                        <td>
                          <label>slug:</label>
                        </td>
                        <td>
                          <input type="text" name="slug" />
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <label>tip:</label>
                        </td>
                        <td>
                          <select name="uType">
                            <option value="KD">KD - katalog</option>
                            <option value="P">P - periodika</option>
                            <option value="D">D - knjige</option>
                            <option value="S">S - serijske</option>
                            <option value="HM">HM - hemeroteka - građa</option>
                            <option value="HM2">HM2 - hemeroteka</option>
                          </select>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <label>broj:</label>
                        </td>
                        <td>
                          <input type="text" name="num" />
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <label>200 a:</label>
                        </td>
                        <td>
                          <input type="text" name="200_a" />
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <label>200 e:</label>
                        </td>
                        <td>
                          <input type="text" name="200_e" />
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <label>210 a:</label>
                        </td>
                        <td>
                          <input type="text" name="210_a" />
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <label>210 c:</label>
                        </td>
                        <td>
                          <input type="text" name="210_c" />
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <label>210 d:</label>
                        </td>
                        <td>
                          <input type="text" name="210_d" />
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <label>300 a:</label>
                        </td>
                        <td>
                          <input type="text" name="300_a" />
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <label>303 a:</label>
                        </td>
                        <td>
                          <input type="text" name="303_a" />
                        </td>
                      </tr>

                      {/* ostala polja dodaješ istim obrascem */}
                    </tbody>
                  </Table>
                )}

                {view === "HM" && (
                  <div>
                    {/* Ovde ide HM forma */}
                    <Table>
                      <tbody>
                        <tr>
                          <td>
                            <label>slug:</label>
                          </td>
                          <td>
                            <input type="text" name="slug" />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label>tip:</label>
                          </td>
                          <td>
                            <select name="uType">
                              <option value="KD">KD - katalog</option>
                              <option value="P">P - periodika</option>
                              <option value="D">D - knjige</option>
                              <option value="S">S - serijske</option>
                              <option value="HM">
                                HM - hemeroteka - gradja
                              </option>
                              <option value="HM2">HM2 - hemeroteka</option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label>broj:</label>
                          </td>
                          <td>
                            <input type="text" name="num" />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label>200 a (Naslov):</label>
                          </td>
                          <td>
                            <input type="text" name="200_a" />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label>210 a (Grad):</label>
                          </td>
                          <td>
                            <input type="text" name="210_a" />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label>210 c (Medij):</label>
                          </td>
                          <td>
                            <input type="text" name="210_c" />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label>210 d (Datum):</label>
                          </td>
                          <td>
                            <input type="text" name="210_d" />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label>600 a (Ličnost):</label>
                          </td>
                          <td>
                            <input type="text" name="600_a" />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label>600 b (Ličnost):</label>
                          </td>
                          <td>
                            <input type="text" name="600_b" />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label>606 a (Tema):</label>
                          </td>
                          <td>
                            <input type="text" name="606_a" />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label>606 w (Tema):</label>
                          </td>
                          <td>
                            <input type="text" name="606_w" />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label>606 x (Tema):</label>
                          </td>
                          <td>
                            <input type="text" name="606_x" />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label>606 y (Tema):</label>
                          </td>
                          <td>
                            <input type="text" name="606_y" />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label>606 z (Tema):</label>
                          </td>
                          <td>
                            <input type="text" name="606_z" />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label>700 a (Autor):</label>
                          </td>
                          <td>
                            <input type="text" name="700_a" />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label>700 b (Autor):</label>
                          </td>
                          <td>
                            <input type="text" name="700_b" />
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                )}

                {/* SAVE BOTTOM */}
                <SaveWrapper>
                  <SaveButton>OK</SaveButton>
                </SaveWrapper>
              </AppWrapper>
            </div>
          </div>
        </div>
      </FullWidth>
    </Page>
  );
};

export default DlUnitEdit;
